import React from "react";
import { ErrorMessage, useField, useFormikContext } from "formik";
import MultiSelectDropdown from "../form/MultiSelectDropdown";
import { formErrorMessage } from "./FormErrorMessage";

// interface FormikMultiSelectProps {
//   name: string;
//   options: { id: number; name: string; value: string }[];
//   placeholder?: string;
//   buttonStyle?: React.CSSProperties;
//   style?: React.CSSProperties;
//   count?: any;
// }

// const FormikMultiSelect: React.FC<FormikMultiSelectProps> = ({
//   name,
//   options,
//   style,
//   buttonStyle,
//   placeholder,
//   count,
// }) => {
//   const [field, meta, helpers] = useField<string[]>({ name });
//   const { setValue } = helpers;
//   const { value = [] } = field;

//   const handleSelect = (val: string) => {
//     if (value.includes(val)) {
//       // Remove
//       setValue(value.filter((v) => v !== val));
//     } else {
//       // Add
//       setValue([...value, val]);
//     }
//   };

//   return (
//     <div className="d-flex flex-column ">
//       <MultiSelectDropdown
//         count={count}
//         style={style}
//         error={!!(meta?.touched && meta?.error)}
//         buttonStyle={buttonStyle}
//         options={options}
//         selected={value}
//         onSelect={handleSelect}
//         placeholder={placeholder}
//       />

//       {meta.touched && meta.error && (
//         <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
//           <ErrorMessage name={name} render={formErrorMessage} />
//         </div>
//       )}
//     </div>
//   );
// };

// export default FormikMultiSelect;


interface FormikMultiSelectProps {
  name: string;
  options: { id: number; name: string; value: string }[];
  placeholder?: string;
  buttonStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  count?: boolean;

  // Async props
  isLoading?: boolean;
  hasMore?: boolean;
  onFetchMore?: () => void;
  className?: string;
}

const FormikMultiSelect: React.FC<FormikMultiSelectProps> = ({
  name,
  options,
  style,
  buttonStyle,
  placeholder,
  count,
  isLoading,
  hasMore,
  onFetchMore,
  className
}) => {
  const [field, meta, helpers] = useField<string[]>({ name });
  const { setValue } = helpers;
  const { value = [] } = field;

  const handleSelect = (val: string) => {
    if (value.includes(val)) {
      setValue(value.filter((v) => v !== val));
    } else {
      setValue([...value, val]);
    }
  };

  return (
    <div className="d-flex flex-column">
      <MultiSelectDropdown
        count={count}
        style={style}
        error={!!(meta?.touched && meta?.error)}
        buttonStyle={buttonStyle}
        options={options}
        selected={value}
        onSelect={handleSelect}
        placeholder={placeholder}
        isLoading={isLoading}
        hasMore={hasMore}
        onFetchMore={onFetchMore}
        className={className}
      />

      {meta.touched && meta.error && (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <ErrorMessage name={name} />
        </div>
      )}
    </div>
  );
};

export default FormikMultiSelect;